// extracted by mini-css-extract-plugin
export default {"card":"F2-z"};